import { CirclePlayIcon, LoaderIcon } from "lucide-react";
import React, { useState } from "react";
import { Button } from "./ui/button";
import { useFlow } from "@/lib/store";
import ResponseDialog, { ResponseDto } from "./response-dialog";

export const SubmitButton: React.FC = () => {
  const { nodes, edges } = useFlow();
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState<ResponseDto | null>(null);

  const handleSubmit = async () => {
    setLoading(true);
    setResponse(null);
    try {
      const response = await fetch("http://localhost:8000/pipelines/parse", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          nodes,
          edges,
        }),
      });

      const data = (await response.json()) as ResponseDto;
      setResponse(data);
    } catch (error) {
      console.error("Error submitting pipeline:", error);
      alert("Failed to analyze pipeline. Please try again.");
      setResponse(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ResponseDialog
        open={!!response}
        response={response}
        setOpen={() => setResponse(null)}
      />
      <Button variant="default" onClick={handleSubmit}>
        {loading ? (
          <LoaderIcon size={16} className="animate-spin" />
        ) : (
          <CirclePlayIcon size={16} />
        )}
        Submit
      </Button>
    </>
  );
};
